import { Skeleton } from '../primitives/Skeleton'
import s from './Loading.module.css'

/**
 * Placeholders in the shape of what's coming. `page`: a row of numbers and two blocks, the shape most screens have.
 * <Screen> shows this until the first data arrives.
 */
export function Loading(props: { shape?: 'page' | 'block' | 'list' }) {
  const shape = props.shape ?? 'block'
  if (shape === 'block') return <Skeleton height="block" />
  if (shape === 'list') {
    return (
      <div className={s.list} role="status" aria-label="Loading">
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} height="line" />
        ))}
      </div>
    )
  }
  return (
    <div className={s.page} role="status" aria-label="Loading">
      <div className={s.stats}>
        <Skeleton height="stat" />
        <Skeleton height="stat" />
        <Skeleton height="stat" />
      </div>
      <Skeleton height="block" />
      <Skeleton height="block" />
    </div>
  )
}
